<template>
  <div class="ranking_container">
    <font-awesome-icon icon="wrench" style="font-size: 2rem" />
    <br />
    <h4>
      under construction
    </h4>
  </div>
</template>

<script>
export default {
  name: "Ranking"
};
</script>

<style>
.ranking_container {
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: top;
}
</style>
